import React from "react";
import PropTypes from "prop-types";

export const TickCircleIcon = (props) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...props}>
    <circle
      cx="12"
      cy="12"
      r="10"
      stroke={props.color ? props.color : "#44C272"}
      strokeWidth="1"
      fill="none"
    />
    <path
      d="M9 12l2 2 5-5"
      stroke={props.color ? props.color : "#44C272"}
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
TickCircleIcon.propTypes = {
  color: PropTypes.string,
};
